import { Button, Form, Input, InputNumber, Tooltip } from "antd";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./BasicFormItem.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

const DowntimeForm = ({ props }) => {
    const { stats } = useSelector(state => state.kpis)
    const { label, placeholder, isRequired, isType, title, text } = props;
    const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 12,
    },
  };
  return (

<Form.Item
  {...formItemLayout}
  label={
    <div style={{ display: "flex", alignItems: "center" }}>
      <p className="sc-form-label">{title}</p>
      <Tooltip
        color="white"
        className="flex tooltip"
        title= {
        <div>
        <div className="dflex">
        <h4 style={{ color: 'black' }}>{text}</h4>
      </div>
      </div>
      }
      >
        <Button
          className="border"
          icon={<InfoCircleOutlined style={{ color: "#909AB4" }} />}
        />
      </Tooltip>
    </div>
  }
  name={label}
  rules={[ { required: true, message: 'Must be a positive number'}, 
  {
    validator: (rule, value) => {
      if (value >= 0) {
        return Promise.resolve();
      }
      return Promise.reject('Must be a positive number');
    }
  }
  ]}
>
  <InputNumber
    className="sc-form-input boxBorder boxBorderRad width100P"
    placeholder={placeholder}
    type={isType}
    name={label}
  />
</Form.Item>
  );
};

export default DowntimeForm;
